<div class="card flex justify-center">
    <p-toast />
    <p-confirmdialog #cd>
        <ng-template #headless let-message let-onAccept="onAccept" let-onReject="onReject">
            @if (message) {
            <div class="flex flex-col items-center p-8 bg-surface-0 rounded">
                <div
                    class="rounded-full bg-primary text-primary-contrast inline-flex justify-center items-center h-24 w-24 -mt-20">
                    <i class="fa-solid fa-circle-exclamation !text-5xl"></i>
                </div>
                <span class="font-bold text-2xl block mb-2 mt-6 text-gray-hiquo">{{ message.header }}</span>
                <p class="mb-0 text-gray-hiquo">{{ message.message }}</p>
                <div class="flex items-center gap-2 mt-6">
                    <p-button label="Confirmar" (onClick)="onAccept()" styleClass="w-32"></p-button>
                    <p-button label="Cancelar" [outlined]="true" (onClick)="onReject()" styleClass="w-32"></p-button>
                </div>
            </div>
            }
        </ng-template>
    </p-confirmdialog>
</div>